import { computed, type Ref } from 'vue';
import { useQuery } from '@vue/apollo-composable';
import { MODULE_REGISTRATION_PAYMENTS } from '@/graphql/Queries/modulePayments';
import type { ModuleRegistrationPaymentsQuery, ModuleRegistrationPaymentsQueryVariables } from '@/types/operations';

export function useModuleRegistrationPayments(ids: Ref<string[]>, enabled: Ref<boolean>) {
  const variables = computed(() => ({ module_ids: ids.value }));
  const { result, loading, error, refetch } = useQuery<ModuleRegistrationPaymentsQuery, ModuleRegistrationPaymentsQueryVariables>(
    MODULE_REGISTRATION_PAYMENTS, variables,
    () => ({ enabled: enabled.value && ids.value.length > 0, fetchPolicy: 'network-only' }),
  );
  const summary = computed(() => {
    const value = result.value?.moduleRegistrationPayments;
    return value && value.modules.length === ids.value.length
      && value.modules.every(module => ids.value.includes(module.module_id)) ? value : null;
  });
  return { summary, loading, error, refetch };
}
